module.exports = __webpack_public_path__ + "img/avatar-90.2dda9112.png";